import { render, staticRenderFns } from "./updatePaymentOptionVip.vue?vue&type=template&id=3e58e3b8&lang=pug"
import script from "./updatePaymentOptionVip.vue?vue&type=script&lang=js"
export * from "./updatePaymentOptionVip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports